import { UNIT } from '../../constants';

export const styles = () => ({
  icon: {
    float: 'left',
    marginLeft: UNIT
  },
  produits: {
    fontSize: UNIT * 0.9375,
    padding: UNIT * 0.625,
    minWidth: UNIT * 10.625
  },
  typo: {
    fontSize: UNIT * 0.875
  },
  listStyle: {
    display: 'inline-block'
  },
  listItemStyle: {
    margin: 'auto',
    width: 'fit-content'
  },
  heading: {
    fontWeight: 700,
    color: '#686B79'
  },
  secondaryStyle: {
    color: '#BABABA!important'
  },
  space: {
    marginTop: UNIT * 0.4375
  }
});
